import React from 'react';
import { useTrackOptimizely } from '@fff-web/fff-analytics';

import { OptimizelyDecision, useDecision } from '@optimizely/react-sdk';
import Carousel from '@fff-web/fff-ui-shared/Carousel';
import { GROWTH_REACTIVATE_MY_MEMBERSHIP_PRODUCT_CAROUSEL } from '../../../utils/Optimizely/featureFlagVariations';
import { generateCarouselProductsList } from './utils';
import { CarouselExperimentVariables, CarouselExperimentProduct } from './types';

import styles from './ReactivateCarousel.module.scss';

interface VariationOnProps {
  experiment: OptimizelyDecision;
  cardClickHandler: () => void;
}

function VariationOn({ experiment, cardClickHandler }: VariationOnProps) {
  const { products, title, subheader } = experiment.variables as CarouselExperimentVariables;
  const productsList: CarouselExperimentProduct[] = products?.list ?? [];
  const carouselProductsList = generateCarouselProductsList(productsList, cardClickHandler);

  return (
    <div className={styles.container}>
      <Carousel variant="product" title={title} subtitle={subheader} items={carouselProductsList} />
    </div>
  );
}

interface Props {
  cardClickHandler: () => void;
}

function ReactivateCarousel({ cardClickHandler }: Props) {
  const [experiment] = useDecision(GROWTH_REACTIVATE_MY_MEMBERSHIP_PRODUCT_CAROUSEL.FEATURE_FLAG);

  useTrackOptimizely(experiment, experiment.ruleKey);

  switch (experiment.variationKey) {
    case GROWTH_REACTIVATE_MY_MEMBERSHIP_PRODUCT_CAROUSEL.VARIATION_ON:
      return <VariationOn experiment={experiment} cardClickHandler={cardClickHandler} />;
    default:
      return null;
  }
}

export default ReactivateCarousel;
